import React, { useCallback, useEffect, useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import type { AppDispatch, RootState } from 'store';
import { PaginateClientsActions as PaginateActions } from 'store/ducks/clients';
import { usePaginationCache } from 'hooks';
import { Scaffold } from 'layouts';
import {
  ClientsList,
  ClientFilters,
  FindClients,
} from 'components/Pages/Clients';
import { Paginator, ListingPageHeader, SettingsMenu } from 'components/Shared';
import * as S from './styles';

export const ClientsListPage: React.FC = () => {
  const dispatch: AppDispatch = useDispatch();

  const { paginationCache, updatePaginationCache, handleFilter, handleSort } =
    usePaginationCache('clients');

  const {
    data: clients,
    pagination,
    loading,
  } = useSelector((state: RootState) => state.paginateClients);

  const [query, setQuery] = useState<FindClients>({
    search: '',
    page: 1,
    limit: 10,
    ...paginationCache,
  });

  const onPageChange = useCallback((page: number): void => {
    setQuery((state) => ({ ...state, page }));
  }, []);

  const onQueryChange = useCallback((): void => {
    dispatch(PaginateActions.request(query));
  }, [dispatch, query]);

  useEffect(() => {
    onQueryChange();
  }, [onQueryChange]);

  useEffect(() => {
    return () => {
      dispatch(PaginateActions.reset());
      updatePaginationCache(query);
    };
  }, [dispatch, query, updatePaginationCache]);

  return (
    <Scaffold>
      <SettingsMenu />
      <S.MainPanel>
        <ListingPageHeader
          icon={<S.CompanyIcon />}
          title="Clientes"
          isLoading={loading}
          actions={
            <S.LinkButton to={'/configuracoes/clientes/criar'} size="small">
              <S.PlusIcon /> Novo cliente
            </S.LinkButton>
          }
        />
        <ClientFilters
          currentFilter={query}
          onFilter={(filter) => handleFilter(query, filter, setQuery)}
        />
        <ClientsList
          clients={clients}
          currentSort={query}
          onSort={(sort) => handleSort(query, sort, setQuery)}
        />
        <Paginator onPageChange={onPageChange} pagination={pagination} />
      </S.MainPanel>
    </Scaffold>
  );
};
